<template>
  <form class="contact-create--form" @submit.prevent="submit">
    <v-layout row wrap>
      <v-flex sm12 class="email-field">
        <strong>Email Address</strong>
        <br />
        {{email}}
        <EditButton @click="editEmail" />
      </v-flex>

      <v-flex xs12 sm12 md6>
        <TextInputCommon
          v-model="model.givenName"
          :validations="inputValidations.firstName"
          display-name="First Name" />
      </v-flex>

      <v-flex xs12 sm12 md6>
        <TextInputCommon
          v-model="model.familyName"
          :validations="inputValidations.lastName"
          display-name="Last Name" />
      </v-flex>

      <v-flex v-if="isRep" xs12>
        <TextInputCommon
          v-model="model.companyName"
          :validations="inputValidations.company"
          display-name="Company (optional)" />
      </v-flex>

      <v-flex xs12 sm12 md6>
        <TextInputCommon
          v-model="model.phone.number"
          :validations="{ ...inputValidations.phone, required: true, min: 10 }"
          display-name="Phone Number"
          mask="###-###-####" />
      </v-flex>

      <v-flex xs12 sm12 md6>
        <SelectPhoneType v-model="model.phone.type" display-name="Type" />
      </v-flex>

      <v-flex xs12>
        <ButtonCommon
          :disabled="loading"
          block
          type="submit"
          variant="secondary">
          Add
        </ButtonCommon>
      </v-flex>
    </v-layout>
  </form>
</template>

<script>
import { Constants } from '@homegauge/vue';

import ButtonCommon from '@/components/common/ButtonCommon.vue';
import EditButton from '@/components/common/EditButton.vue';
import SelectPhoneType from '@/components/common/SelectPhoneType.vue';
import TextInputCommon from '@/components/common/TextInputCommon.vue';
import PhoneTypes from '@/constants/phone-types';

const DEFAULT_MODEL = {
  type: Constants.AccountTypes.CUSTOMER,
  companyName: '',
  email: '',
  familyName: '',
  givenName: '',
  phone: {
    number: '',
    type: PhoneTypes.mobile.value,
  },
};

export default {
  $_veeValidate: {
    validator: 'contact-create',
  },
  components: {
    ButtonCommon,
    EditButton,
    SelectPhoneType,
    TextInputCommon,
  },
  props: {
    type: {
      type: String,
      default: Constants.AccountTypes.CUSTOMER,
    },
    email: {
      type: String,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      inputValidations: Constants.InputValidations,
      model: {
        ...DEFAULT_MODEL,
        type: this.type,
        email: this.email,
      },
    };
  },
  computed: {
    isRep() {
      return this.model.type === Constants.AccountTypes.REAL_ESTATE_PROFESSIONAL;
    },
  },
  methods: {
    editEmail() {
      this.$emit('editEmail');
    },
    async submit() {
      const isValid = await this.$validator.validateAll();
      if (isValid) {
        this.$emit('submit', this.model);
      }
    },
  },
};
</script>
